import { Flex } from '@/app/ui/atoms';

interface AudioPlayerProps {
  audioUrl: string;
  style?: React.CSSProperties;
}

const AudioPlayer = ({ audioUrl, style }: AudioPlayerProps) => (
  <Flex.Container style={style}>
    <audio controls>
      <source src={audioUrl} type="audio/mpeg" />
      <track kind="captions" src="" />
      Your browser does not support the audio element.
    </audio>
  </Flex.Container>
);

export default AudioPlayer;
